<template>
  <!-- 編輯頁面本體-->
  <div class="incsall ">
    <!--刪除區塊-->
    <DeleteModal :deleteModal="deleteModal" @init="init()"></DeleteModal>

    <!--要有檢視權限-->
    <div v-if="pagepermission.isView">
      <div v-if="!detail">
        <!--列表及查詢區塊-->
        <b-row><b-col>
            <b-form-input v-model="search.keywords" placeholder="請輸入關鍵字" maxlength="100"></b-form-input></b-col>
          <b-col>
            <b-form-select v-model="search.status" :options="statusSearchOptions"
              class="only-button-down"></b-form-select></b-col>
          <b-col>
            <b-form-select v-model="search.langurage" :options="langSearchOptions"
              class="only-button-down"></b-form-select></b-col>
          <b-col cols="2"><b-button @click="cancelSearch" v-if="checkSearchIsEmpty() == true" title="清空查詢條件">
              <b-icon icon="x-circle"></b-icon></b-button><b-button @click="init" title="開始查詢">
              <b-icon icon="search"></b-icon></b-button></b-col>
          <b-col cols="2"><b-button @click="_go('?lang=1&PJID=' + PJ_ID + '&modal=' + modal + '&id=null')"
              v-if="pagepermission.isInsert">新增</b-button></b-col></b-row>
        <b-table-simple>
          <b-thead>
            <b-tr>
              <b-th>語系</b-th>
              <b-th>姓名</b-th>
              <b-th>狀態</b-th>
              <b-th>異動人員</b-th>
              <b-th>異動日期</b-th>
              <b-th>修改</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="item in contentList" :key="item.id + '-' + item.langurage">
              <b-td>{{langSearchOptions.find(x => x.value == item.langurage).text}}</b-td>
              <b-td>
                {{ htmlDecode(item.title) }}
              </b-td>
              
              <b-td>{{statusOptions.find(x => x.value == item.deployStatus).text}}</b-td>
              <b-td>{{ item.modifierName ? item.modifierName : item.creatorName }}</b-td>
              <b-td>{{ item.modifierName ? dateFormat(item.modifyDate) : dateFormat(item.createDate) }}</b-td>
              <b-td class="btn_edit">
                <b-button variant="info" class="mr-3"
                  @click="_go('?lang=' + item.langurage + '&PJID=' + PJ_ID + '&modal=' + modal + '&id=' + item.id)"
                  v-if="pagepermission.isUpdate">編輯</b-button>
                <a href="javascript:" class="btn_delete" v-if="pagepermission.isDelete"
                  @click="functionDelete(item)"><img src="/images/backend/del_icon.png" alt="刪除icon" /></a></b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <div class="page mt-2">
          <span class="pagination-total">共 {{ Math.ceil(pagination.rows / pagination.perPage) }}
            頁．{{ pagination.rows }}筆資料</span>
          <b-pagination class="pagination light-theme simple-pagination" v-model="pagination.page"
            :total-rows="pagination.rows" :per-page="pagination.perPage" aria-controls="my-table"></b-pagination>
        </div>
      </div>
      <div v-else>
        <!--內容區塊-->
        <div class="incsal">
          <div class="btare">
            <div class="backrul">
              <a :href="'?lang=' + lang + '&PJID=' + PJ_ID + '&modal=' + modal">返回查詢結果</a>
            </div>
          </div>

          <!--切換語系區塊-->
          <div class="language_div p-3 mb-2">
            <button id="toTw" :class="'btn ' + (this.lang == '1' ? 'btn-danger selected' : 'btn-secondary')"
              @click="toLang('tw')">中文版</button>
            <button id="toEn" :class="'btn ' + (this.lang == '2' ? 'btn-danger selected' : 'btn-secondary')"
              @click="toLang('en')">英文版</button>
          </div>
          <!--設定區塊-->
          <b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg">
            <b-row>
              <b-col>
                <label class="text-danger" for="startDate">上架時間*</label>
                <b-form-datepicker name="startDate" class="mb-2" clear-button placeholder="選擇上架日期"
                  v-model="contentDetail.startDate"
                  :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }">
                </b-form-datepicker>
              </b-col>
              <b-col>
                <label for="endDate">下架時間</label>
                <b-form-datepicker name="endDate" class="mb-2" reset-button reset-button-text="清除日期"
                  placeholder="選擇下架日期" v-model="contentDetail.endDate"
                  :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }">
                </b-form-datepicker>
              </b-col>
              <b-col>
                <label class="text-danger" for="Displaystatus">發布狀態*</label>
                <b-form-select name="Displaystatus" class="only-button-down" v-model="contentDetail.deployStatus"
                  :options="statusOptions">
                </b-form-select>
              </b-col>
              <b-col>
                <label class="text-danger" for="sort">排序*</label>
                <b-form-input
                    type="number"
                    min=0
                    class="nospin"
                    v-model="contentDetail.sort">
                    </b-form-input>
              </b-col>
            </b-row>
          </b-form-group>

          <!--姓名區塊-->
          <div class="title_div p-3 mb-2 bkbor">
            <label class="text-danger" for="title">{{ (lang == 1) ? "中文" : "英文" }}姓名*</label>
            <b-form-input name="title" placeholder="請輸入姓名" required maxlength="200" v-model="contentDetail.title">
            </b-form-input>
          </div>

          <!--上傳照片-->
          <div class="photo_div p-3 mb-2 bkbor">
            <b-row>
              <label>圖片上傳 (建議上傳尺寸 W:450 x H:550 px)</label>
            </b-row>
            <b-row>
              <div>
                <b-form-file
                  accept=".jpg,.png"
                  v-model="contentDetail.file"
                  ref="file-input"
                  class="mb-2"
                  placeholder="尚未選擇任何檔案"
                  browse-text="選擇檔案">
                </b-form-file>
                <button v-if="contentDetail.file || contentDetail.filePath" v-on:click="removed_img()" class="btn_delete">
                  <img src="/images/backend/del_icon.png" alt="刪除icon">
                </button>
              </div>
            </b-row>
            <label v-if="contentDetail.filePath">預覽</label>
            <b-row v-if="contentDetail.filePath">
                <div class="rulnal">
                    <div class="viewvd">
                        <img :src="'/filestore'+contentDetail.filePath" alt="imgPathError" width="640" onerror="this.src='../../images/default.jpg'"/>
                    </div>
                </div>
            </b-row>
          </div>


          <!--教授資訊區塊-->
          <b-form-group class="doctorInfo_div p-3 mb-2 bkbor" label-size="lg">
            <b-row>
              <b-col>
                <label for="job">職稱</label>
                <b-form-input name="job" class="mb-2" placeholder="請輸入職稱" required v-model="job">
                </b-form-input>
              </b-col>
              <b-col>
                <label for="phone">電話</label>
                <b-form-input name="phone" placeholder="請輸入電話" required v-model="phone">
                </b-form-input>
              </b-col>
              <b-col v-if="now_special.fax.need_show">
                <label for="fax" >{{now_special.fax.title}}</label>
                <b-form-input name="fax" :placeholder="'請輸入'+now_special.fax.title" required v-model="fax">
                </b-form-input>
              </b-col>
              <b-col>
                <label for="email">E-mail</label>
                <b-form-input name="email" placeholder="請輸入E-mail" required v-model="email">
                </b-form-input>
              </b-col>
            </b-row>
          </b-form-group>

          <!--研究領域區塊-->
          <b-form-group class="Research_div p-3 mb-2 bkbor" label-size="lg"  v-if="now_special.research.need_show">
            <!--標題-->
            <b-col>
              <b-row>
                <label class="clso_title">{{now_special.research.title}}</label>
              </b-row>
            </b-col>
            <!--建立按鈕-->
            <b-col>
              <b-row class="addnewclass">
                <input id="Research_input" class="Research_input" v-model="research_input"/>
                <button v-on:click="insert_item('research', research_input)">新增</button>
              </b-row>
            </b-col>
            <!--項目清單-->
            <b-col class="clasoptn">
              <b-row v-for="(item ,index) in research_list" v-bind:key="index" class="clasoptn_row">
                <div class="EmployingAgency_item clasoptn_item">
                  <label>{{ item }}</label>
                  <button
                    type="button"
                    :aria-label="'移除'+now_special.research.title+'：'+item"
                    @click="remove_item('research',index)">
                    <img src="/images/backend/del_icon.png" alt="刪除icon" />
                  </button>
                </div>
              </b-row>
            </b-col>
          </b-form-group>

          <!--開設課程區塊-->
          <b-form-group class="CoursesOffered_div p-3 mb-2 bkbor" label-size="lg" v-if="now_special.offered.need_show">
            <!--標題-->
            <b-col>
              <b-row>
                <label class="clso_title">{{ now_special.offered.title }}</label>
              </b-row>
            </b-col>
            <!--建立按鈕-->
            <b-col>
              <b-row class="addnewclass">
                <input id="CoursesOffered_input" class="CoursesOffered_input" v-model="offered_input"/>
                <button v-on:click="insert_item('offered', offered_input)">新增</button>
              </b-row>
            </b-col>
            <!--項目清單-->
            <b-col class="clasoptn">
              <b-row v-for="(item ,index) in offered_list" v-bind:key="index" class="clasoptn_row">
                <div class="EmployingAgency_item clasoptn_item">
                  <label>{{ item }}</label>
                  <button
                    type="button"
                    :aria-label="'移除'+now_special.offered.title+'：'+item"
                    class="btn_delete"
                    @click="remove_item('offered',index)">
                    <img src="/images/backend/del_icon.png" alt="刪除icon" />
                  </button>
                </div>
              </b-row>
            </b-col>
          </b-form-group>

          <!--學歷區塊-->
          <b-form-group class="EducationalBackground_div p-3 mb-2 bkbor" label-size="lg" v-if="now_special.educational.need_show">
            <!--標題-->
            <b-col>
              <b-row>
                <label class="clso_title">{{now_special.educational.title }}</label>
              </b-row>
            </b-col>
            <!--建立按鈕-->
            <b-col>
              <b-row class="addnewclass">
                <input id="EducationalBackground_input" class="EducationalBackground_input" v-model="educational_input"/>
                <button v-on:click="insert_item('educational', educational_input)">新增</button>
              </b-row>
            </b-col>
            <!--項目清單-->
            <b-col class="clasoptn">
              <b-row v-for="(item ,index) in educational_list" v-bind:key="index" class="clasoptn_row">
                <div class="EmployingAgency_item clasoptn_item">
                  <label>{{ item }}</label>
                  <button
                    type="button"
                    :aria-label="'移除'+now_special.educational.title+'：'+item"
                    class="btn_delete"
                    @click="remove_item('educational',index)">
                    <img src="/images/backend/del_icon.png" alt="刪除icon" />
                  </button>
                </div>
              </b-row>
            </b-col>
          </b-form-group>

          <!--服務機關區塊-->
          <b-form-group class="EmployingAgency_div p-3 mb-2 bkbor" label-size="lg" v-if="now_special.service.need_show">
            <!--標題-->
            <b-col>
              <b-row>
                <label class="clso_title">{{ now_special.service.title }}</label>
              </b-row>
            </b-col>
            <!--建立按鈕-->
            <b-col>
              <b-row class="addnewclass">
                <input id="EmployingAgency_input" class="EmployingAgency_input" v-model="service_input"/>
                <button v-on:click="insert_item('service', service_input)">新增</button>
              </b-row>
            </b-col>
            <!--項目清單-->
            <b-col class="clasoptn">
              <b-row v-for="(item ,index) in service_list" v-bind:key="index" class="clasoptn_row">
                <div class="EmployingAgency_item clasoptn_item">
                  <label>{{ item }}</label>
                  <button
                    type="button"
                    :aria-label="'移除'+now_special.service.title+'：'+item"
                    class="btn_delete"
                    @click="remove_item('service',index)">
                    <img src="/images/backend/del_icon.png" alt="刪除icon" />
                  </button>
                </div>
              </b-row>
            </b-col>
          </b-form-group>

          <!--後台系統紀錄區塊 (若無資料則不顯示)-->
          <b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg"
            v-if="contentDetail.creatorName || contentDetail.modifierName">
            <!--建檔記錄-->
            <b-row v-if="contentDetail.creatorName">
              <b-col>
                <span>建檔紀錄：</span>
                <!--建檔記錄格式 = 建檔帳號(建立時間 yyyy-mm-dd HH:MM:ss) -->
                <span>{{ contentDetail.creatorName }}({{ datetimeFormatFloat(contentDetail.createDate) }})</span>
              </b-col>
            </b-row>
            <!--異動紀錄-->
            <b-row v-if="contentDetail.modifierName">
              <b-col>
                <span>異動紀錄：</span>
                <!--異動記錄格式 = 異動帳號(異動時間 yyyy-mm-dd HH:MM:ss) -->
                <span>{{ contentDetail.modifierName }}({{ datetimeFormatFloat(contentDetail.modifyDate) }})</span>
              </b-col>
            </b-row>
          </b-form-group>
          <div class="Operation_div">
            <b-button id="save_btn" class="btn btn-secondary" v-if="pagepermission.isInsert || pagepermission.isUpdate"
              @click="save">儲存</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
 
</template>
<script>
import DeleteModal from "../../Tool/deleteModal.vue";
export default {
  components: {
    /*TinyMceEditor,*/
    DeleteModal,
  },
  data() {
    return {
      detail: false,
      //以POST方式傳送
      formData: new FormData(),
      //查詢條件
      search: { status: null, langurage: null },
      initSeach: false,
      //頁數設定  
      pagination: {
        perPage: 10,
        page: 1,
        rows: 5,
      },
      contentList: [],
      contentDetail: {},
      //刪除模板
      deleteModal: {
        id: null,
        classes: null,
        parent: null,
        show: false,
        type: "Member",
      },
      //發布狀態查詢選項		  
      statusSearchOptions: [
        { value: null, text: '全部發布狀態' },
        { value: 1, text: '開啟' },
        { value: 2, text: '關閉' },
      ],
      //語系查詢選項
      langSearchOptions: [
        { value: null, text: '全部語系' },
        { value: 1, text: '中文版' },
        { value: 2, text: '英文版' },
      ],
      //發布狀態編輯選項				  
      statusOptions: [
        { value: null, text: '請選擇' },
        { value: 1, text: '開啟' },
        { value: 0, text: '關閉' },
      ],
      //權限編號
      PJ_ID: "",
      //類別編號
      typeId: "1",
      //文章編號
      id: "",
      //語系
      lang: "1",
      //樣式編號
      modal: "2",
      //是否開啟刪除介面
      deleteConfirm: false,
      //單位權限
      pagepermission: {},

      //職稱
      job:"",
      //電話
      phone:"",
      //傳真
      fax:"",
      //email
      email:"",

      //新增研究領域
      research_input:"",
      //研究領域清單
      research_list:[],
      //新增開設課程
      offered_input:"",
      //開設課程清單
      offered_list:[],
      //新增學歷
      educational_input:"",
      //學歷清單
      educational_list:[],
      //新增服務機關
      service_input:"",
      //服務機關清單
      service_list:[],
      //特殊顯示清單
      special_list:[
        {
          //專任教授
          PJ_ID:"PJ20250501",
          fax:{
            title:"傳真",
            need_show:true,
          },
          research:{
              title:"研究領域",
              need_show:true,
            },
          offered:  
            {
              title:"開設課程",
              need_show:true,
            },
          educational:
            {
              title:"學歷",
              need_show:true,
            },
          service:
            {
              title:"研究室",
              need_show:true,
            },
        },
        {
          //兼任教授
          PJ_ID:"PJ20250502",
          fax:{
            title:"傳真",
            need_show:true,
          },
          research:
            {
              title:"研究領域",
              need_show:true,
            },
          offered:
            {
              title:"開設課程",
              need_show:true,
            },
          educational:
            {
              title:"現職",
              need_show:true,
            },
          service:  
            {
              title:"經歷",
              need_show:true,
            },
        },
        {
          //退休教授
          PJ_ID:"PJ20250503",
          fax:{
            title:"退休年份",
            need_show:true,
          },
          research:
          {
            title:"研究領域",
            need_show:false,
          },
          offered:
          {
            title:"開設課程",
            need_show:false ,
          },
          educational:
          {
            title:"現任",
            need_show:false,
          },
          service:
          {
            title:"主要經歷",
            need_show:true,
          },
        },
        {
          //行政人員
          PJ_ID:"PJ20250504",
          fax:{
            title:"傳真",
            need_show:false,
          },
          research:
          {
            title:"研究領域",
            need_show:false,
          },
          offered:
          {
            title:"開設課程",
            need_show:false,
          },
          educational:
          {
            title:"學歷",
            need_show:false,
          },
          service:
          {
            title:"主要業務",
            need_show:true,
          },
        },
        {
          //名譽人員
          PJ_ID:"PJ20250506",
          fax:{
            title:"退休年份",
            need_show:true,
          },
          research:
          {
            title:"研究領域",
            need_show:false,
          },
          offered:
          {
            title:"開設課程",
            need_show:false,
          },
          educational:
          {
            title:"現任",
            need_show:false,
          },
          service:
          {
            title:"主要經歷",
            need_show:true,
          },
        
        },
      ],
      //當前樣式顯示
      now_special:{},


      //API設定區
      apiMember: (data) => this.userRequest.post("bicd/Member2", data),
    };
  },
  props: ["value"],
  computed: {},
  mounted() {
    this.init();
  },
  watch: {
    "$route.query"() {
      this.init();
    },
    "pagination.page"() {
      this.init();
    },
    value() {
      //初始化
      this.init();
    },
    //權限
    permission() {
      this.pagepermission = this.permission;
    }
  },
  methods: {
    async init() {
      //類別編號
      this.PJ_ID = this.value.PJID;
      //類別內部編號
      this.typeId = Number(this.value.typeId);
      //文章編號
      this.id = this.value.id;
      //語系
      this.lang = this.value.lang ? this.value.lang : 1;
      //樣式編號
      this.modal = this.value.modal;

      //取得畫面權限
      this.getPermission(this.PJ_ID);

      this.initSeach = false;

      if (this.id == undefined) {
        //查詢文章內容
        window.scrollTo(0, 0);
        this.detail = false;
        this.initSeach = true;

        try {
          this.contentList = {};
          let jsonReq = {
            TYPE: "LIST",
            VerifyCode: this.PJ_ID,
            member_SELECT: {
              langurage: this.search.langurage,
              typeId: this.typeId,
              keywords: this.search.keywords,
              startDate: this.search.startDate,
              endDate: this.search.endDate,
              deployStatus: this.search.status,
              pageIndex: this.pagination.page,
              pageSize: this.pagination.perPage,
            },
          };
          let resToken = await this.userRequest.post(
            "bicd/Token"
          );
          jsonReq.Token = resToken.data;
          let res = await this.userRequest.post(
            "bicd/Member",
            jsonReq
          );
          let json = JSON.parse(res.data);
          
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.contentList = jsonData.outData;
            this.pagination.rows = jsonData.totalCount;
          }
        } catch (err) {
          console.log(err);
        }
        this.checkSearchIsEmpty();
      } else {
        //取得當前類別的特殊版面
        this.now_special = this.special_list.find(item => item.PJ_ID == this.PJ_ID)|| {
            fax:{title:"傳真",need_show:false,},
            research: { title: "研究領域", need_show: true },
            offered: { title: "開設課程", need_show: true },
            educational: { title: "學歷", need_show: true },
            service: { title: "服務機關", need_show: true }
        };
       
        //修改文章內容
        this.detail = true;
        this.initSeach = false;

        try {
          this.contentDetail = {};
          let jsonReq = {
            TYPE: "SELECT",
            VerifyCode: this.PJ_ID,
            member_SELECT: {
              id: this.id,
              typeId: this.typeId,
              langurage: this.lang,
            },
          };
          let resToken = await this.userRequest.post(
            "bicd/Token"
          );
          jsonReq.Token = resToken.data;
          let res = await this.userRequest.post(
            "bicd/Member",
            jsonReq
          );
          let json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);

            if (jsonData) {
              this.contentDetail = jsonData;
              this.contentDetail.title = this.htmlDecode(this.contentDetail.title);
              const detail = JSON.parse(jsonData.description);
              this.job = detail.job;
              this.phone = detail.phone;
              this.fax = detail.fax;
              this.email = detail.email;
              this.research_list = Array.isArray(detail.research)? detail.research:[];
              this.offered_list = Array.isArray(detail.offered)? detail.offered:[];
              this.educational_list = Array.isArray(detail.educational)? detail.educational:[];
              this.service_list = Array.isArray(detail.service)? detail.service:[];
            } else {
              this.contentDetail = {};
              this.contentDetail = {
                startDate: new Date().toISOString(),
                linkMethod: '_self',
                deployStatus: null,
                sort: 1,
              };
              this.job = "";
              this.phone = "";
              this.fax = "";
              this.email = "";
              this.research_list = [];
              this.offered_list =[];
              this.educational_list = [];
              this.service_list = [];
            }
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    functionDelete(item) {
      this.deleteModal.show = true;
      this.deleteModal.id = item.id;
      this.deleteModal.type = "Member";
      this.deleteModal.langurage = item.langurage;
      this.deleteModal.VerifyCode = this.PJ_ID;
    },
    save() {
      //將目前資訊整合，並送出
      //新增特殊資料組合
        const description = this.buildDescription();
        this.formData = new FormData();
        this.formData.append("TYPE", "SAVE");
        this.formData.append("VerifyCode", this.PJ_ID);
        this.formData.append("langurage", this.lang);
        this.formData.append("id",this.id);
        this.formData.append("typeId", this.typeId);
        this.formData.append("model", this.modal);
        this.formData.append("title", this.contentDetail.title);
        this.formData.append("description", description);
        this.formData.append("startDate", this.contentDetail.startDate);
        this.formData.append("endDate", this.contentDetail.endDate);
        this.formData.append("deployStatus", this.contentDetail.deployStatus);
        this.formData.append("sort", this.contentDetail.sort);
        this.formData.append("publicUnit", this.contentDetail.publicUnit);
        this.formData.append("filepath", this.contentDetail.filePath == null ? "" : this.contentDetail.filePath);
        this.formData.append("httpPostedFile", this.contentDetail.file == undefined? null : this.contentDetail.file);
        this.FunctionToken(this.functionSaveContent2, {});
    },
    //新增/修改功能
    functionSaveContent(data) {
      this.apiMember(data)
        .then((res) => {
          let json = JSON.parse(res.data);
          if (json.Status) {
            this.$bvToast.toast("儲存成功", {
              title: "提示",
              solid: true,
            });
            this._go("?lang=" + this.lang + "&PJID=" + this.PJ_ID + "&modal=" + this.modal);
          } else {
            alert(this.Str_Replace(JSON.parse(json.Data), ",", "\r\n"));
          }
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    //新增/修改功能
    functionSaveContent2(data) {
      this.formData.append("Token", data.Token);
      this.apiMember(this.formData)
        .then((res) => {
          let json = JSON.parse(res.data);
          this.formData = new FormData();
          if (json.Status) {
            this.$bvToast.toast("儲存成功", {
              title: "提示",
              solid: true,
            });
            this._go("?lang=" + this.lang + "&PJID=" + this.PJ_ID + "&modal=" + this.modal);
          } else {
            alert(this.Str_Replace(JSON.parse(json.Data), ",", "\r\n"));
          }
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    cancelSearch() {
      this.search = { status: null, langurage: null };
      this.init();
    },
    //切換語系
    toLang(click_lang) {

      if (click_lang == 'tw' && this.lang != '1') {
        //進入中文介面 
        if (this.isEdited) {
          //確認是否不儲存就離開
          if (!confirm("還有尚未儲存的資料，請問是否直接離開")) {
            return;
          }
        }
        this._go("?PJID=" + this.PJ_ID + "&typeId=" + this.typeId + "&modal=" + this.modal + ((this.id != undefined && this.id != '') ? "&id=" + this.id : "") + "&lang=1");

      } else if (click_lang == 'en' && this.lang != '2') {
        //進入英文介面
        if (this.isEdited) {
          //確認是否不儲存就離開
          if (!confirm("還有尚未儲存的資料，請問是否直接離開")) {
            return;
          }
        }
        this._go("?PJID=" + this.PJ_ID + "&typeId=" + this.typeId + "&modal=" + this.modal + ((this.id != undefined && this.id != '') ? "&id=" + this.id : "") + "&lang=2");
      }
    },
    //建立內容資料
    buildDescription(){
      return JSON.stringify({
        job:this.job,
        phone:this.phone,
        fax:this.fax,
        email:this.email,
        research:[...this.research_list],
        offered:[...this.offered_list],
        educational:[...this.educational_list],
        service:[...this.service_list],
      })
    },
    //新增資料到各清單中
    insert_item(list_name,item_name){
      if( item_name== " " || item_name == ""){
        alert("欄位資料不能為空");
        return;
      }
      switch(list_name){
        //研究領域
        case "research":
          if(this.research_list.includes(item_name)){
            alert("研究領域已有該筆資料，請確認輸入資料");
          }else {
            this.research_list.push(item_name);
            this.research_input = "";
          }
          break;
        //開設課程
        case "offered":
          if(this.offered_list.includes(item_name)){
            alert("開設課程已有該筆資料，請確認輸入資料");
          }else {
            this.offered_list.push(item_name);
            this.offered_input = "";
          }
          break;
        //學歷
        case "educational":
          if(this.educational_list.includes(item_name)){
            alert("學歷已有該筆資料，請確認輸入資料");
          }else {
            this.educational_list.push(item_name);
            this.educational_input = "";
          }
          break;
        //服務機關
        case "service":
          if(this.service_list.includes(item_name)){
            alert("服務機關已有該筆資料，請確認輸入資料");
          }else {
            this.service_list.push(item_name);
            this.service_input = "";
          }
          break;
      }
    },
    //移除資料到各清單中
    remove_item(list_name,index){
       const lists = {
        research: this.research_list,
        offered: this.offered_list,
        educational: this.educational_list,
        service: this.service_list,
      };

      const list = lists[list_name];
      list.splice(index,1);
    },
    //移除圖片
    removed_img(){
      const imgconf = window.confirm('是否確認刪除圖片？');
      if(!imgconf) return;
      this.contentDetail.file = null;
      this.contentDetail.filePath = null;
      this.contentDetail.fileExt = null;
      this.contentDetail.fileSize = null;
      this.contentDetail.fileName = null;
    }
  },
};

</script>
